import { FC } from "react";
import { Drawer, Row, Col, Button, Divider, Menu } from 'antd';
import { obtenerIcono } from "../util/AppIcons";
import { MenuProps } from 'rc-menu';
import { obtieneMenuItem } from "../../antd-reducer/menu-reducer";
import { labelsPreheaderMobile } from "../../mocks/PreHeaderMock";


type MenuItem = Required<MenuProps>['items'][number];


const items: MenuItem[] = [
    obtieneMenuItem('Inicio', '1'),
    obtieneMenuItem('Comprar', '2'),
    obtieneMenuItem('Financiamiento', '3'),
    obtieneMenuItem('Mas', 'sub1', null, 
    [
        obtieneMenuItem('Vende Dueño', '5'),
        obtieneMenuItem('Publica tu Auto', '6'),
    ]),


];





export const MenuMobile:FC<{ open:boolean}> = (props) => {
        return (
            <Drawer
            closable={false} width={"100%"} height={"100%"}
            style={{ marginTop: "56px", width: "100%"}}
            placement="top"  open={props.open}>
            <Row justify='center'>
              <Col>
                <span>{obtenerIcono("login-mobile")}  </span>
  
              </Col>
              <Col>
                <label style={{ paddingBottom: "588px" }}>¡Hola!</label>
  
              </Col>
            </Row>
            <Row justify='center'> 
  
  
              <Col>
                <Button style={{ width: "330px", height: "48px" }} type='primary'><label className="button-text">Iniciar sesión</label> </Button>
  
              </Col>
            </Row>
  
            <Divider></Divider>
            <Menu
              style={{ width: "100%", background: "white" , paddingLeft:"28px" }}
              defaultSelectedKeys={['1']}
              mode="inline"
              items={items}
            />
  
            <div style={{background: "#DBDBDB" , height:"100%" , width:"100%" ,paddingLeft:"28px" , paddingTop:"28px" }}>


              {
                labelsPreheaderMobile.map((_ , index) => (

                  <>
                <a  rel="noreferrer"  href={_.link}  className='preheader-data-mobile'>{_.text}</a><br/>
                  
                  </>
                   
                ))
              }
             
            </div>
          </Drawer>
        )
}